import axios from "axios";
import processW from "../../models/workflow/processW";
import processId from "../../models/workflow/processId";
import concept from "../../models/workflow/concept";
import conceptLic from "../../models/workflow/conceptLic";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getProcess() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/procesos`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return processW.fromJson(item);
        });
      });
  }
  getValidateProcess() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/procesos/validate`, { headers })
      .then(({ data }) => {
        return data;
      });
  }

  getProcessId(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data;
    return axios
      .get(`${url}/workflow/procesos/${id}`, { headers })
      .then(({ data }) => {
        return processId.fromJson(data);
      });
  }
  getConcepts() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/conceptos`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return concept.fromJson(item);
      });
    });
  }
  getConceptsLic() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/conceptos/lic`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return conceptLic.fromJson(item);
      });
    });
  }
  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      nombre: data.name,
      descripcion: data.description,
      tipo: data.type,
      conceptoId: data.concept == null ? undefined : data.concept,
    };

    return axios.post(`${url}/workflow/procesos`, payload, { headers });
  }
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const procesoId = data;

    return axios.delete(`${url}/workflow/procesos/${procesoId}`, {
      headers,
    });
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const processId = data.id;

    let payload = {
      nombre: data.name,
      descripcion: data.description,
      tipo: data.type,
    };
    if (data.concept) {
      payload = {
        ...payload,
        conceptoId: data.concept,
      };
    }

    return axios
      .patch(`${url}/workflow/procesos/${processId}`, payload, { headers })
      .then(() => {});
  }
}
export default service;
